import React, { useState } from "react";

const About = React.forwardRef((props, ref) => {
  const [showFullText, setShowFullText] = useState(false);

  const fullText = (
    <h3 className=" text-xl text-[#000]">
      We are a pioneering social enterprise committed to eradicating energy
      poverty in Nigeria's rural communities. We are focused on providing
      uninterrupted access to clean cooking gas (LPG) and ensuring its
      affordability through our Waste-to-Fuel mechanism which allows recyclables
      to be used as an alternative mode of payment for cooking gas and gas
      accessories.
      <button
        className="text-[#38761d] font-bold"
        onClick={() => setShowFullText(false)}
      >
        Read Less
      </button>
    </h3>
  );

  const truncatedText = (
    <h3 className=" text-xl text-[#000]">
      We are a pioneering social enterprise committed to eradicating energy
      poverty in Nigeria's rural communities. We are focused on providing
      uninterrupted access to clean cooking gas...
      <button
        className="text-[#38761d] font-bold"
        onClick={() => setShowFullText(true)}
      >
        Read More
      </button>
    </h3>
  );

  return (
    <main className=" bg-[#f9f9f9]">
      <div
        ref={ref}
        className="pt-12 pb-6 flex flex-col gap-7 items-center w-[90%] mx-auto justify-center"
      >
        <div className=" flex flex-col gap-7">
          <h1 className="text-4xl md:text-6xl text-[#f46524]">About Us</h1>
          <div className="flex flex-col gap-4 text-xl text-[#000]">
            {showFullText ? fullText : truncatedText}
          </div>
        </div>
        <div className="grid lg:grid-cols-3 gap-4  p-4 mx-auto">
          <div className=" mx-auto py-4 flex flex-col gap-2  p-4  bg-[#38761d] rounded-lg hover:shadow-md shadow-2xl cursor-pointer">
            <img
              src="/images/vision-img.png"
              title="vision-img"
              alt="vision-img"
              className="lg:h-[80px] md:h-[80px] md:w-[80px] lg:w-[80px] mx-auto h-[50px] w-[50px]"
            />
            <h1 className="text-2xl md:text-4xl text-[#fff] text-center">
              Our Vision
            </h1>
            <div className="flex flex-col gap-4">
              <h2 className=" text-center text-white">
                To play a leading role in ending energy poverty and contribute
                to creating a cleaner, healthier, and sustainable Africa.
              </h2>
            </div>
          </div>

          <div className=" mx-auto py-4 flex flex-col gap-2 p-4  bg-[#38761d] rounded-lg hover:shadow-md shadow-2xl cursor-pointer">
            <img
              src="/images/mission-icon.png"
              title="mission-icon"
              alt="mission-icon"
              className="lg:h-[80px] md:h-[80px] md:w-[80px] lg:w-[80px] mx-auto h-[50px] w-[50px]"
            />
            <h1 className="text-2xl md:text-4xl text-[#fff] text-center">
              Our Mission
            </h1>
            <div className="flex flex-col gap-4">
              <h2 className=" text-center text-white">
                To revolutionize energy access and affordability in low-income
                communities across Nigeria and Africa by redefining waste as a
                valuable resource.
              </h2>
            </div>
          </div>
          <div className=" mx-auto py-4 flex flex-col gap-2 p-4  bg-[#38761d] rounded-lg hover:shadow-md shadow-2xl cursor-pointer">
            <img
              src="/images/standingout.png"
              title="standingout-icon"
              alt="standingout-icon"
              className="lg:h-[80px] md:h-[80px] md:w-[80px] lg:w-[80px] mx-auto h-[50px] w-[50px]"
            />
            <h1 className="text-2xl md:text-4xl text-[#fff] text-center">
              Standing Out
            </h1>
            <div className="flex flex-col gap-4">
              <h2 className=" text-center text-white">
                You may think we're just another energy company. But we aren't.
                We are radically redefining how clean cooking energy is made
                accessible and affordable for low-income communities.
              </h2>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
});

export default About;
